"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModal = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const react_i18next_1 = require("react-i18next");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
// Make sure Modal knows what DOM element is the app container. Available examples in the package documentation all put this line outside the component.
if (!process.env.IS_TESTING) {
    react_modal_1.default.setAppElement('#app');
}
/**
 * Modal component displaying a simple text with a single OK button
 *
 * @param props Component props
 * @returns The modal component
 */
const SimpleModal = (props) => {
    const close = (ev) => {
        if (typeof props.action === 'function') {
            props.action(ev);
        }
        props.closeModal(ev);
    };
    return (react_1.default.createElement(react_modal_1.default, { isOpen: props.isOpen, onRequestClose: props.closeModal, className: "react-modal", overlayClassName: "react-modal-overlay", contentLabel: props.title },
        react_1.default.createElement("div", null,
            props.title && (react_1.default.createElement("h3", { className: "center" },
                react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, props.title))),
            props.containsHtml ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.text } })) : (react_1.default.createElement("div", { className: "help-popup" },
                react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, props.text))),
            react_1.default.createElement("div", { className: "center" },
                react_1.default.createElement("button", { className: "button blue", onClick: close }, props.t('main:OK'))))));
};
exports.SimpleModal = SimpleModal;
exports.default = (0, react_i18next_1.withTranslation)()(exports.SimpleModal);
//# sourceMappingURL=SimpleModal.js.map